class StoreKeys {
	static get CurrentUser() { return "currentUser" }
	static get LoginLocked() { return "loginLocked" }
	static get DataChanged() { return "dataChanged" }
}

class SysMessages {
	static get RecordSaved() { return "Record saved successfully." }
	static get RecordDeleted() { return "Record deleted successfully." }
	static get OperationError() { return "Error in performing operation. Check system logs for more details" }
	static get Unauthorized() { return "You are not authorized to perform this action." }
	static get BadGateway() { return "Error connecting to server. Please check your internet connection." }
	static get NotFound() { return "Not Found. The resource you requested can not be found." }
	static get NotAllowed() { return "Response to preflight request doesn't pass access control check: No 'Access-Control-Allow-Origin' header is present on the requested resource." }
}

class Routes {
	static get Login() { return "login" }
	static get UnAuthorized() { return "unauthorized" }
	static get Dashboard() { return "dashboard" }
	static get Reports() { return "reports" }
	static get ReportViewer() { return "reportViewer" }
	static get Settings() { return "settings" }
	static get GenericSettings() { return "settings.lookup" }
	static get Admin() { return "admin" }
	static get Users() { return "admin.users" }
	static get Roles() { return "admin.roles" }
	static get ChangePassword() { return "changePassword" }
	static get TopUpRequest() { return "topuprequest" }
	static get TopUpPayment() { return "topupPayment" }
	static get MessagePortal() { return "messageportal" }
	static get Address() { return "address" }
	static get Contacts() { return "address.contacts" }
	static get Groups() { return "address.groups" }
}


class PartialViews {
	static get UserForm() { return "user_form" }
	static get RoleForm() { return "role_form" }
	static get MenuBar() { return "menubar" }
	static get Header() { return "header" }
	static get DocumentViewer() { return "doc_viewer" }
	static get MessengerForm() { return "messenger_form" }
	static get DataUpload() { return "data_upload" }
	static get ContactForm() { return "contact_form" }
	static get GroupForm() { return "group_form" }
}


class AngularServices {
	static get Q() { return "$q" }
	static get Http() { return "$http" }
	static get State() { return "$state" }
	static get StateParams() { return "$stateParams" }
	static get UibModal() { return "$uibModal" }
	static get Scope() { return "$scope" }
	static get RootScope() { return "$rootScope" }
	static get UibModalInstance() { return "$uibModalInstance" }
	static get Location() { return "$location" }
	static get HotKeys() { return "hotkeys" }
}

class AppServices {
	static get BaseApi() { return "BASEAPI" }
	static get AuthService() { return "AuthService" }
	static get RequestInterceptor() { return "RequestInterceptor" }
	static get CustomerService() { return "CustomerService" }
	static get ProductService() { return "ProductService" }
	static get SupplierService() { return "SupplierService" }
	static get UserService() { return "UserService" }
	static get RoleService() { return "RoleService" }
	static get StockService() { return "StockService" }
	static get ReportsConfig() { return "ReportsConfig" }
	static get ReportService() { return "ReportService" }
	static get LookUpService() { return "LookUpService" }
	static get StatsService() { return "StatsService" }
	static get TopUpService() { return "TopUpService" }
	static get MessengerCtrl() { return 'MessengerCtrl' }
	static get MessagePortalCtrl() { return 'MessagePortalCtrl' }
	static get DataUploadService() { return "DataUploadService" }
	static get ContactService() { return "ContactService" }
	static get GroupService() { return "GroupService" }
	static get MessageService() { return "MessageService" }
}

class AppControllers {
	static get LoginCtrl() { return 'LoginCtrl' }
	static get UserProfileCtrl() { return 'UserProfileCtrl' }
	static get MainCtrl() { return 'MainCtrl' }
	static get DashboardCtrl() { return 'DashboardCtrl' }
	static get CustomerCtrl() { return 'CustomerCtrl' }
	static get SupplierCtrl() { return 'SupplierCtrl' }
	static get ProductCtrl() { return 'ProductCtrl' }
	static get SettingsCtrl() { return 'SettingsCtrl' }
	static get SettingCtrl() { return 'SettingCtrl' }
	static get UsersCtrl() { return 'UsersCtrl' }
	static get RolesCtrl() { return 'RolesCtrl' }
	static get ReportsCtrl() { return 'ReportsCtrl' }
	static get ReportViewerCtrl() { return 'ReportViewerCtrl' }
	static get PreviewerCtrl() { return 'PreviewerCtrl' }
	static get TopUpPaymentCtrl() { return 'TopUpPaymentCtrl' }
	static get TopUpRequestCtrl() { return 'TopUpRequestCtrl' }
	static get ContactsCtrl() { return 'ContactsCtrl' }
	static get GroupsCtrl() { return 'GroupsCtrl' }
	static get DataUploadCtrl() { return 'DataUploadCtrl' }
	static get MessengerCtrl() { return 'MessengerCtrl' }
	static get MessagePortalCtrl() { return 'MessagePortalCtrl' }
}

class LookUpStores {
	static get Users() { return "users" }
	static get Titles() { return "titles" }
	static get Groups() { return "groups" }
}



export { StoreKeys, SysMessages, Routes, PartialViews, AppServices, AngularServices, AppControllers, LookUpStores }


// WEBPACK FOOTER //
// ./app/helpers/config_keys.ts